import * as mocks from "./mocks";

const mockingKey = "mocked";

window.availableMocks = () => {
	return Object.values(mocks).map(m => m[0]);
};

window.currentMocks = () => {
	let storedMocks = window.localStorage.getItem(mockingKey);
	storedMocks = JSON.parse(storedMocks) ?? {};

	return storedMocks;
};

window.unmockAll = () => {
	const current = Object.keys(window.currentMocks());

	current.forEach(m => window.unmockRequest(m));
};

window.mockRequest = (key) => {
	const currentMocks = window.currentMocks();
	currentMocks[key] = true;

	window.localStorage.setItem(mockingKey, JSON.stringify(currentMocks));
};

window.unmockRequest = (key) => {
	let storedMocks = window.localStorage.getItem(mockingKey);
	storedMocks = JSON.parse(storedMocks) ?? {};
	delete storedMocks[key];

	if(Object.keys(storedMocks).length === 0)
		window.localStorage.removeItem(mockingKey);
	else
		window.localStorage.setItem(mockingKey, JSON.stringify(storedMocks));
};

//this will follow the form of ['key-for-mock', (uri) => bool, {} | (resp) => resp]
export function mockDataInterceptor() {
	return {
		response(resp) {
			const activeMocks = Object.keys(window.currentMocks());

			if(activeMocks.length === 0)
				return resp;

			const applicable = Object.values(mocks)
				.filter(mock => activeMocks.includes(mock[0]))
				.filter(mock => mock[1](resp));
			
			if(applicable?.length) {
				for(const mock of applicable) {
					mock[2](resp);
				}
			}
			
			return resp;
		}, 
		responseError: (err) => {
			const activeMocks = Object.keys(window.currentMocks());

			if(activeMocks.length === 0)
				throw err;
			
			const resp = Object.values(mocks)
				.filter(mock => mock?.[1](err) && activeMocks.includes(mock[0]))
				.reduce((accumulatedResp, currentMock) => {
					return currentMock[2](accumulatedResp); 
				}, err);

			return resp;
		}
	};
}
